import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  bottom: 48px;
  left: 20px;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0;

  @media screen and (max-height: 800px) {
    bottom: 24px;
  }
  @media screen and (max-width: 900px) {
    position: ${props => (props.notStatic ? 'absolute' : 'static')};
    width: ${props => (props.fullWidth ? '100%' : 'auto')};
    flex-direction: row;
    justify-content: ${props => (props.centerItems || props.centerInPage ? 'center' : 'flex-start')};
    bottom: 12px;
    background: ${props => (props.notStatic && !props.clear ? props.theme.colors.white : 'transparent')};
  }
  @media screen and (max-width: 500px) {
    bottom: 0px;
    left: 0px;
  }
  @media screen and (max-width: 600px) and (max-height: 400px) {
    bottom: 0px;
  }
`;

export const PlusButton = styled.button`
  position: relative;
  z-index: 5;
  margin-top: 12px;
  width: 36px;
  height: 36px;
  border: 0;
  background: ${props => (props.clear ? 'transparent' : props.theme.colors.white)};
  cursor: pointer;
  padding: 4px;
  img {
    pointer-events: none;
  }

  @media screen and (max-width: 900px) {
    margin-top: 0px;
    margin-left: 12px;
    align-self: flex-end;
  }
`;

export const SocialLink = styled.a`
  width: 36px;
  height: 36px;
  background: transparent;
  position: relative;
  img {
    width: 36px;
    height: auto;
    pointer-events: none;
  }
`;

export const SocialLinkWrapper = styled.div`
  margin-top: 12px;

  @media screen and (max-width: 900px) {
    margin-left: 12px;
    margin-top: 0px;
  }
`;
